import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=abe1bc0a"
import script from "./Default.vue?vue&type=script&setup=true&lang=js"
export * from "./Default.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abe1bc0a')) {
      api.createRecord('abe1bc0a', component.options)
    } else {
      api.reload('abe1bc0a', component.options)
    }
    module.hot.accept("./Default.vue?vue&type=template&id=abe1bc0a", function () {
      api.rerender('abe1bc0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/buttons/Default.vue"
export default component.exports